import { bool, func, string } from 'prop-types';
import React from 'react';
import { Card, CardFooter, Form, FormGroup, Input, Label } from 'reactstrap';

import { creativeShape } from '../../../prop-types';
import CreativeCardImage from '../../CreativeCardImage';

function SelectableCreative({ checked, creative, onChange, sizeType }) {
  const id = `selectable-creative-${creative.id}`;

  return (
    <Form inline>
      <FormGroup check className="w-100 text-center">
        <Label for={id} className="cursor-pointer">
          <Input
            type="checkbox"
            id={id}
            data-id={creative.id}
            checked={checked}
            onChange={onChange}
            className="d-none"
          />
          <Card className={checked ? 'border-primary' : undefined}>
            <CreativeCardImage creative={creative} top />
            <CardFooter className="px-2 py-1 bg-white small text-muted">
              {sizeType}
            </CardFooter>
          </Card>
        </Label>
      </FormGroup>
    </Form>
  );
}

SelectableCreative.propTypes = {
  checked: bool,
  creative: creativeShape.isRequired,
  onChange: func.isRequired,
  sizeType: string.isRequired,
};

SelectableCreative.defaultProps = {
  checked: false,
};

export default SelectableCreative;
